// Debug utilities for tracking down websocket and Chrome extension issues

export const debugWebSocket = {
    // Log all websocket events with timestamps
    logEvent: (event, data) => {
        const timestamp = new Date().toISOString()
        console.log(`[${timestamp}] WebSocket ${event}:`, data)
    },

    // Monitor for Chrome extension conflicts
    monitorExtensions: () => {
        // Check if any extensions are interfering
        const originalSend = WebSocket.prototype.send
        const originalClose = WebSocket.prototype.close

        let sendCount = 0
        let closeCount = 0

        WebSocket.prototype.send = function (data) {
            sendCount++
            console.log(`🔍 WebSocket.send() called #${sendCount}:`, data)
            return originalSend.call(this, data)
        }

        WebSocket.prototype.close = function (code, reason) {
            closeCount++
            console.log(`🔍 WebSocket.close() called #${closeCount}:`, { code, reason })
            return originalClose.call(this, code, reason)
        }

        return () => {
            WebSocket.prototype.send = originalSend
            WebSocket.prototype.close = originalClose
        }
    },

    // Monitor for Chrome extension messaging errors
    monitorChromeErrors: () => {
        const originalError = console.error
        const originalWarn = console.warn

        console.error = (...args) => {
            const message = args.join(' ')
            if (message.includes('listener indicated an asynchronous response') ||
                message.includes('message channel closed')) {
                console.log('🚨 CHROME EXTENSION ERROR DETECTED:', message)
                console.log('🚨 Stack trace:', new Error().stack)
            }
            originalError.apply(console, args)
        }

        console.warn = (...args) => {
            const message = args.join(' ')
            if (message.includes('listener indicated an asynchronous response') ||
                message.includes('message channel closed')) {
                console.log('🚨 CHROME EXTENSION WARNING DETECTED:', message)
            }
            originalWarn.apply(console, args)
        }

        return () => {
            console.error = originalError
            console.warn = originalWarn
        }
    },

    // Check for potential conflicts
    checkConflicts: () => {
        const conflicts = []

        // Check for multiple WebSocket instances
        const wsInstances = document.querySelectorAll('*')
        let wsCount = 0
        wsInstances.forEach(el => {
            if (el.constructor.name === 'WebSocket') wsCount++
        })

        if (wsCount > 1) {
            conflicts.push(`Multiple WebSocket instances detected: ${wsCount}`)
        }

        // Check for Chrome extension interference
        if (window.chrome && window.chrome.runtime) {
            conflicts.push('Chrome extension API detected - potential conflict source')
        }

        // Check for service workers
        if ('serviceWorker' in navigator) {
            conflicts.push('Service Worker detected - potential conflict source')
        }

        return conflicts
    },

    // Generate debug report
    generateReport: () => {
        const report = {
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            websocketSupport: typeof WebSocket !== 'undefined',
            chromeExtension: !!(window.chrome && window.chrome.runtime),
            serviceWorker: 'serviceWorker' in navigator,
            conflicts: debugWebSocket.checkConflicts(),
            memoryUsage: performance.memory ? {
                used: Math.round(performance.memory.usedJSHeapSize / 1024 / 1024),
                total: Math.round(performance.memory.totalJSHeapSize / 1024 / 1024),
                limit: Math.round(performance.memory.jsHeapSizeLimit / 1024 / 1024)
            } : 'Not available'
        }

        console.log('🔍 Debug Report:', report)
        return report
    }
}

// Auto-start monitoring in development
if (process.env.NODE_ENV === 'development') {
    console.log('🔍 Starting WebSocket debug monitoring...')
    debugWebSocket.monitorChromeErrors()
    debugWebSocket.generateReport()
}












